module.exports = __webpack_public_path__ + "static/img/indexText8.103ea26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexText8.png
// module id = LMHm
// module chunks = 1